import { useContext } from 'react';

import { AuthContext } from '../context/AuthContext';

function useAuth() {
  const {
    installAuthInterceptor,
    login,
    loginByCode,
    isPrevPassword,
    forgotPassword,
    forgotPasswordSubmit,
    logout,
    confirmMfaCode,
    loginContext,
    mfaContext,
    isLoggedIn,
    loggedInUser,
  } = useContext(AuthContext);

  return {
    installAuthInterceptor,
    login,
    loginByCode,
    isPrevPassword,
    forgotPassword,
    forgotPasswordSubmit,
    logout,
    confirmMfaCode,
    loginContext,
    mfaContext,
    isLoggedIn,
    loggedInUser,
  };
}

export default useAuth;
